import axios from 'axios';
import { Message } from 'element-ui';

axios.defaults.baseURL = 'http://api.hrx-chin.com/';
//axios.defaults.baseURL = 'http://localhost:8080/';
axios.defaults.withCredentials = true;
axios.defaults.timeout = 60000;
axios.defaults.timeoutErrorMessage = 'Axios request timeout, please try again';

axios.interceptors.response.use(response => {
    return response.data

}, error => {
    if (error.response) {
        Message.error('服务器内部错误，请稍后再试');

        if (error.response.data) {
            throw error.response.data;
        }
    }
    return Promise.reject(error);
});

export default {
    root: (() => axios.defaults.baseURL)(),
    get(url, params) {
        return axios.get(url, { params: params });
    },
    formPost(url, params) {
        let data = new URLSearchParams();
        if (params) {
            for (let i in params) {
                data.append(i, params[i])
            }
        }
        return axios.post(url, data, {
            headers: [
                { 'content-type': 'x-www-form-urlencoded' }
            ]
        })
    },
    jSONPost(url, params) {
        return axios.post(url, params);
    },
    put(url, params) {
        return axios.put(url, params)
    },
    delete(url, params) {
        return axios.delete(url, { params: params });
    },
    downLoad(url,fileName){
        return downLoadApi(url,fileName);
    },
    getUrl:axios.defaults.baseURL,
    imageUrl:"http://hrx-image.qingjiufeng.com/",
    //imageUrl:"http://qe5ps4fhz.bkt.clouddn.com/",
    
}

export function downLoadApi(url, name) {
    getBlob(url, function(blob) {
        saveAs(blob, name);
      });
  }
 /**
 * 获取 blob
 * @param  {String} url 目标文件地址
 * @return {cb}
 */
function getBlob(url, cb) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function() {
      if (xhr.status === 200) {
        cb(xhr.response);
      }
    };
    xhr.send();
  }
  
  /**
   * 保存
   * @param  {Blob} blob
   * @param  {String} filename 想要保存的文件名称
   */
  function saveAs(blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      var body = document.querySelector("body");
  
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
  
      // fix Firefox
      link.style.display = "none";
      body.appendChild(link);
  
      link.click();
      body.removeChild(link);
  
      window.URL.revokeObjectURL(link.href);
    }
  } 